<template>
    <div class="time-usage-skills">

        <div class="employee-switcher">
            <div class="employee-switcher-option" @click="employeeWorkingFieldName = ''" :class="{'selected': employeeWorkingFieldName === ''}">
                Alle medarbejdere
            </div>
            <div class="employee-switcher-option" @click="employeeWorkingFieldName = 'Svend, funktionær'" :class="{'selected': employeeWorkingFieldName === 'Svend, funktionær'}">
                Svende, funktionær
            </div>
            <div class="employee-switcher-option" @click="employeeWorkingFieldName = 'Svend, timelønnet'" :class="{'selected': employeeWorkingFieldName === 'Svend, timelønnet'}">
                Svende, timelønnet
            </div>
            <div class="employee-switcher-option" @click="employeeWorkingFieldName = 'Lærling'" :class="{'selected': employeeWorkingFieldName === 'Lærling'}">
                Lærlinge
            </div>
        </div>

        <div class="row">
            <div class="col-lg-8">
                 <div class="placeholder fit-content">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="employees.timeUsageSkills" />
                        Hvor gode er vi til at registrere tid?
                    </div>
                    <div class="placeholder" v-if="data && !loading">
                        <vue-good-table
                            :columns="columns"
                            :rows="data.employees"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            v-if="data"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div v-if="props.column.field == 'available_hours'" style="text-align:left;">
                                    {{ props.row.available_hours | number }}
                                </div>
                                <div v-else-if="props.column.field == 'logged_hours'" style="text-align:left;">
                                    {{ props.row.logged_hours | number }}
                                </div>
                                <div v-else-if="props.column.field == 'full_name'" class="table-column__description" :title="props.row.full_name">
                                    {{ props.row.full_name }}
                                </div>
                                <div v-else-if="props.column.field == 'weekly_hours_working'" style="text-align:left;">
                                    {{ props.row.weekly_hours_working }}
                                </div>
                                <div v-else-if="props.column.field == 'avg_per_week'" style="text-align:left;">
                                    {{ props.row.avg_per_week | number }}
                                </div>
                                <div v-else-if="props.column.field == 'efficiency'" class="coverage-cell" style="text-align:left;">
                                    <span>
                                        {{ props.row.efficiency | rounded }}
                                        <span v-if="props.row.efficiency">%</span>
                                    </span>
                                    <div
                                        v-if="props.row.efficiency"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.efficiency < $store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': $options.filters.rounded(props.row.efficiency) >= $store.state.config.companyMeta.settings.timelogging.medium.value, 'good': $options.filters.rounded(props.row.efficiency) >= $store.state.config.companyMeta.settings.timelogging.high.value}"
                                    />
                                </div>
                                <div v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>
                    </div>

                    <div class="placeholder padding" v-else-if="!data && !loading">
                        Vi kunne ikke hente data. Tjek, at du har angivet hvilke svende, der skal baseres data på under indstillinger.
                    </div>

                    <box-loading height="350" v-else />
                </div>
                <br>
                OBS! Der vises kun medarbejdere, som har registreret tid i den valgte periode.
            </div>
            <div class="col-lg-4">
                 <div class="placeholder fit-content">
                    <div class="placeholder__heading">
                        Opsummering
                    </div>
                    <div class="placeholder padding" v-if="data && !loading">
                        <div class="highlight">
                            <div class="text">
                                Timer til rådighed
                            </div>
                            <div class="value">
                                {{ data.totals.available_hours | number }}
                            </div>
                        </div>
                        <div class="highlight">
                            <div class="text">
                                Timer registreret
                            </div>
                            <div class="value">
                                {{ data.totals.logged_hours | number }}
                            </div>
                        </div>
                        <br>
                        <div class="highlights" align="center">
                            <div class="value" style="font-size:30px;font-weight:bold;display:flex;align-items:center;justify-content:center;">
                                <div
                                    v-if="data.totals.efficiency"
                                    class="coverage-indicator"
                                    :class="{'bad': data.totals.efficiency < $store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': $options.filters.rounded(data.totals.efficiency) >= $store.state.config.companyMeta.settings.timelogging.medium.value, 'good': $options.filters.rounded(data.totals.efficiency) >= $store.state.config.companyMeta.settings.timelogging.high.value}"
                                />
                                {{ data.totals.efficiency | rounded }} %
                            </div>
                            <div class="text">
                                Af timer til rådighed er registreret
                            </div>
                        </div>
                    </div>

                    <div class="placeholder padding" v-else-if="!data && !loading">
                        Vi kunne ikke hente data. Tjek, at du har angivet hvilke svende, der skal baseres data på under indstillinger.
                    </div>
                    
                    <box-loading height="350" v-else />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .highlight {
        display: flex;
        justify-content: space-between;
        
        &:not(:last-of-type) {
            margin-bottom: $margin--small;
            padding-bottom: $margin--small;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        }

        .text {

        }

        .value {
            font-weight: bold;
        }
    }

</style>

<script>
import * as timeUsageService from '@/services/timeUsageService'

export default {
    data () {
        return {
            employeeWorkingFieldName: '',
            loading: true,
            data: null,
            columns: [
                { label: 'Initialer', field: 'initials', type: 'string' },
                { label: 'Medarbejder', field: 'full_name', type: 'string' },
                { label: 'Timer til rådighed', field: 'available_hours', type: 'number' },
                { label: 'Timer registreret', field: 'logged_hours', type: 'number' },
                { label: 'Registreret tid', field: 'efficiency', type: 'number' }
                /* { label: 'Timer i alt', field: 'total_hours', type: 'number' },
                { label: 'Timer/uge', field: 'weekly_hours_working', type: 'number' },
                { label: 'Realiseret/uge', field: 'avg_per_week', type: 'number' },
                { label: 'Effektivitet', field: 'efficiency', type: 'number' } */
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'efficiency',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.data = null
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            if (this.employeeWorkingFieldName !== '') {
                params.working_field_name = this.employeeWorkingFieldName
            }
            timeUsageService.skills(params, (response) => {
                this.data = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        },
        employeeWorkingFieldName: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// timeUsageSkills.vue?ea7048dc